import * as common from 'store/modules/common'
import { toast } from 'react-toastify'
import { localize } from 'store/modules/localization'
import { api } from './api'

const newEntity = {
  name: '',
  address: '',
  address2: '',
  zipCode: '',
  city: '',
  web: '',
  email: '',
  id: 0,
  country: null,
  vineyardStyle: null,
  produceStyle: null,
  comment: '',
  phoneNumber: '',
  canBeDeleted: true
}

export const actionTypePrefix = 'producers'

export { api }
export const initialState = { ...common.initialState }
export const actionTypes = { ...common.actionTypes(actionTypePrefix) }
export const actionCreators = {
  ...common.actionCreators(actionTypePrefix, api),

  save: (entity, callback, notificationText) => (dispatch, getState) => {
    dispatch({ type: actionTypes.saving })
    let updateApi = (entity.id === 0 ? api.create : api.update)
    const { isDirty, saveAsSupplier, ...data } = entity
    if (saveAsSupplier) { updateApi = api.saveAsSupplier }
    updateApi(data)
      .then(response => {
        dispatch({ type: actionTypes.saved, payload: response })
        toast.info(localize(getState().localization, notificationText || 'common.saved'))
        if (typeof callback === 'function') { callback(response) }
      })
      .catch(error => common.handleError(actionTypePrefix, { getState, dispatch, error, update: { saving: false } }))
  },
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.create: return { ...state, entity: { ...newEntity, isDirty: true } }
    default: return common.reducer(state, action, actionTypePrefix)
  }
}

